import { render } from "./Export.vue?vue&type=template&id=89518b2a"
import script from "./Export.vue?vue&type=script&lang=js"
export * from "./Export.vue?vue&type=script&lang=js"
script.render = render

export default script